import styled from "@emotion/styled";
import { Close, Info } from "@mui/icons-material";
import {
  Box,
  Chip,
  IconButton,
  Tooltip,
  Typography,
  Zoom,
} from "@mui/material";

export const CustomIconButton = styled((props) => (
  <IconButton
    inputProps={{
      "aria-label": "weight",
    }}
    {...props}
  />
))(({ theme }) => ({
  color: "white",
}));

export const CustomIconButtonForSheet = styled((props) => (
  <IconButton
    inputProps={{
      "aria-label": "weight",
    }}
    {...props}
  />
))(({ theme }) => ({
  // color: "#5f6368",
  height: "1.1rem",
  width: "1.1rem",
  padding: "0 !important",
  borderRadius: "50%",
  backgroundColor: "#6C6C6C",
  "&:hover": {
    backgroundColor: "#6C6C6C",
  },
  "& svg": {
    fill: "#fff",
  },
}));

export const CustomChip = styled((props) => (
  <Chip
    color="secondary"
    style={{
      color: "white",
      borderRadius: "4px",
      ...(props?.style || {}),
    }}
    size="small"
    deleteIcon={<Close color="primary" />}
    {...props}
  />
))(({ theme }) => ({
  color: "white",
}));

export const CustomInfoButton = styled((props) => (
  <Tooltip
    enterTouchDelay={0}
    title={
      <Box
        container
        style={{
          minWidth: "8vw",
        }}
      >
        {props.header && (
          <Typography fontSize="20px" fontWeight={500} color="primary">
            {props.header}
          </Typography>
        )}
        {props.body && (
          <Typography color="primary" fontWeight={300} fontSize="12px">
            {props.body}
          </Typography>
        )}

        {props?.equipments && (
          <Box display="flex" marginTop={2} gap={1}>
            {props?.equipments.map((eq, i) => (
              <Chip
                size="small"
                style={{
                  color: "#000",
                  borderRadius: "11px",
                  backgroundColor: "#fff",
                  fontSize: "12px",
                }}
                key={i}
                label={eq}
              />
            ))}
          </Box>
        )}
      </Box>
    }
    arrow
    {...props}
    TransitionComponent={Zoom}
  >
    {/* <img src={infoIcon} alt="" /> */}
    <Info color="primary" />
  </Tooltip>
))(({ theme }) => ({
  color: "white",
  cursor: "pointer",
}));
